import { render, staticRenderFns } from "./selMaterial.vue?vue&type=template&id=2c8c1376&scoped=true"
import script from "./selMaterial.vue?vue&type=script&lang=js"
export * from "./selMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c1376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8c1376')) {
      api.createRecord('2c8c1376', component.options)
    } else {
      api.reload('2c8c1376', component.options)
    }
    module.hot.accept("./selMaterial.vue?vue&type=template&id=2c8c1376&scoped=true", function () {
      api.rerender('2c8c1376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QIP/selMaterial.vue"
export default component.exports